import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthService,private router:Router // private modalService: NgbModal
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        
        if (err.status === 401) {
          // auto logout if 401 response returned from api
     
       //   this.authenticationService.logout().subscribe(()=>{
 
            localStorage.removeItem("user");
      
            this.router.navigate(['authentication/signin'], {
              queryParams: {},
            });
        }
        if (err.status === 500) {
          // auto logout if 500 response returned from api
     
        //  this.authenticationService.logout().subscribe(()=>{
 
          //  localStorage.removeItem("user");
      
          //  this.router.navigate(['authentication/signin'], {
          //    queryParams: {},
         //   });
      
            //document.location.reload();
      //
    
         // });       
        //  location.reload();
      

        }

        const error = err.error.message || err.statusText;
        return throwError(error);
      })
    );
  }

 
}
